import React from "react";
import { Crown, Sparkles, Gift } from "lucide-react";

export const PlanBadge = ({ plan = "free", size = "md" }) => {
  const styles = {
    free: {
      classes: "bg-slate-100 border-slate-200 text-slate-600",
      icon: Gift,
      label: "Free Plan",
    },
    pro: {
      classes: "bg-[#1D6AFF]/10 border-[#1D6AFF]/25 text-[#1D6AFF]",
      icon: Sparkles,
      label: "Pro",
    },
    elite: {
      classes: "bg-amber-50 border-amber-300 text-amber-700",
      icon: Crown,
      label: "Elite",
    },
  };
  const s = styles[plan] || styles.free;
  const Icon = s.icon;
  const pad = size === "lg" ? "px-3.5 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span data-testid={`plan-badge-${plan}`} className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${s.classes} ${pad}`}>
      <Icon className="w-3.5 h-3.5" />
      {s.label}
    </span>
  );
};

export default PlanBadge;
